export default function ({ $auth, redirect, store }) {
    if ($auth.loggedIn)
        if ($auth.user.is_vendor) redirect('/vendor/dashboard')
        else redirect('/dashboard')
}
